import { cartFieldsQuery } from './getCart'
import { gql } from './gql'

/**
 * Get's the string for `cartAddProduct` mutation.
 * This mutation adds a product to an existing cart.
 */
export const CART_ADD_PRODUCT = gql`
  mutation CartAddProductMutation(
    $cartAddProductSessionUid: ID!
    $cartAddProductStorefrontName: String!
    $cartAddProductData: CartProductOpInput!
  ) {
    cartAddProduct(
      sessionUid: $cartAddProductSessionUid
      storefrontName: $cartAddProductStorefrontName
      data: $cartAddProductData
    ) {
      ${cartFieldsQuery}
    }
  }
`
